import api from '../api';

export const contentCockpitService = {
  overview: (clientId, month) => api.get('/content-cockpit', { params: { clientId, month } }),
  publish: (articleId, publishedUrl) => api.post('/content-cockpit/publish', { articleId, publishedUrl }),
  clearPublish: (articleId) => api.post('/content-cockpit/clear-publish', { articleId }),
  urlAudit: () => api.get('/content-cockpit/url-audit.xlsx', { responseType: 'blob' }),
  requestGenerations: (payload) => api.post('/content-cockpit/generation-requests', payload),
  listGenerationRequests: (status = 'pending') =>
    api.get('/content-cockpit/generation-requests', { params: { status } }),
  pendingGenerationCount: () => api.get('/content-cockpit/generation-requests/pending-count'),
  decideGenerationRequest: (id, payload) =>
    api.patch(`/content-cockpit/generation-requests/${id}`, payload),
};
